import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class LandingGuardGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) { }

  canActivate(route: any, state: any): boolean | UrlTree {
    if (!this.authService.isAuthenticated()) {
      return true;
    }

    const user = this.authService.getCurrentUser();
    if (user?.id && user.role !== 'admin') {
      return this.router.createUrlTree([user.strategy_admin ? '/strategy-manager-home' : '/strategy-executor-home']);
    }
    if (user?.role === 'admin') {
      return this.router.createUrlTree(['/admin/admin-home']);
    }

    return true;
  }
}
